import { SectionHeader } from '../common/SharedComponents';
import { Link } from 'react-router-dom';
import Paper from '@material-ui/core/Paper';

function TemplatesLanding() {
    const styles = {
        linkPaper: {
            color: '#2C5591',
            textAlign: 'center',
            padding: 50,
            fontSize: 14,
            margin: 20,
            width: 300,
        },
        loginPaper: {
            color: '#2C5591',
            padding: 20,
            fontSize: 14,
            margin: 20,
        },
        flexContainer: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-evenly',
            overflow: 'auto',
        },
        verticalPadding: {
            paddingTop: 50,
            paddingBottom: 50,
        },
    };

    return (
        <>
            <SectionHeader
                title='Templates'
                buttonText=''
            />
            <div
                className='main-content'
                style={{ padding: 0 }}
            >
                <div
                    className='row scrollable-content'
                    style={styles.flexContainer}
                >
                    <Link
                        to='/templates/icca'
                        style={styles.verticalPadding}
                    >
                        <Paper
                            style={styles.linkPaper}
                            elevation={3}
                        >
                            <h1>ICCA</h1>
                            <p>View/Update ICCA templates</p>
                        </Paper>
                    </Link>
                    <Link
                        to='/templates/termsheets'
                        style={styles.verticalPadding}
                    >
                        <Paper
                            style={styles.linkPaper}
                            elevation={3}
                        >
                            <h1>Termsheets</h1>
                            <p>View/Update Termsheet templates</p>
                        </Paper>
                    </Link>
                    <Link
                        to='/templates/agreements'
                        style={styles.verticalPadding}
                    >
                        <Paper
                            style={styles.linkPaper}
                            elevation={3}
                        >
                            <h1>User Agreements</h1>
                            <p>View/Update User Agreement templates</p>
                        </Paper>
                    </Link>
                    <Link
                        to='/templates/notices'
                        style={styles.verticalPadding}
                    >
                        <Paper
                            style={styles.linkPaper}
                            elevation={3}
                        >
                            <h1>Notices</h1>
                            <p>View/Update Notice templates</p>
                        </Paper>
                    </Link>
                </div>
            </div>
        </>
    );
}

export default TemplatesLanding;
